import React from "react";
import styled from "styled-components";
import APIPage from "../Integrations/API";
import { Redirect } from "react-router-dom";
import SidebarSearch from "../SidebarSearch";
import SidebarLayers from "../SidebarLayers";
import SidebarProfile from "../SidebarProfile";
import SidebarProjects from "../SidebarProjects";
import CesiumIon from "../Integrations/CesiumIon";
import SidebarDashboard from "../SidebarDashboard";
import SidebarAppLibrary from "../SidebarAppLibrary";
import WebMapService from "../Integrations/WebMapService";

const Wrapper = styled.div`
  width: 39.6rem;
  max-height: 100vh;
  overflow-y: overlay;
  background-color: #2F2F2F;

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #707173;
    // border: 1px solid gray;    
  }
  &::-webkit-scrollbar {
    width: 6px;
    background-color: #2F2F2F;
    // border: 1px solid black;
  }
  padding: 2rem 2.5rem 2rem;
  color: ${({ theme }) => theme.textColor.secondary};
  border-right: 1px solid ${({ theme }) => theme.backgroundColor.sidebar};
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    width: 100vw;
    height: calc(100% - 4.8rem);
  }
`;

const DrawerContent = ({ content, project, onCreate, onClose, goToCesiumIonPage, goToWebMapServicePage, goToAPIPage, goToProfilePage }) => {
  if (content === "profile") return <SidebarProfile onClose={onClose} goToCesiumIonPage={goToCesiumIonPage} goToWebMapServicePage={goToWebMapServicePage} goToAPIPage={goToAPIPage} />;

  if (content === "search") return <SidebarSearch onClose={onClose} onCreate={onCreate} />;

  if (content === "projects") return <SidebarProjects onClose={onClose} project={project} />;

  if (content === "layers") return <SidebarLayers onClose={onClose} />;

  if (content === "applibrary") return <SidebarAppLibrary onClose={onClose} />;

  if (content === "cesium") return <CesiumIon goToProfilePage={goToProfilePage} />

  if (content === "webservice") return <WebMapService goToProfilePage={goToProfilePage} />

  if (content === "api") return <APIPage goToProfilePage={goToProfilePage} />

  if (content === "dashboard") {
    if (localStorage.is_user_manager === 'true') {
      return <Redirect to="/admin" />
    } else {
      return <SidebarDashboard onClose={onClose} />
    }
  }

  return null;
};

const SidebarDrawer = ({ content, onClose, onCreate, project, goToCesiumIonPage, goToWebMapServicePage, goToAPIPage, goToProfilePage, ...props }) => (
  <Wrapper {...props}>
    <DrawerContent
      content={content}
      onClose={onClose}
      onCreate={onCreate}
      project={project}
      goToCesiumIonPage={goToCesiumIonPage}
      goToAPIPage={goToAPIPage}
      goToWebMapServicePage={goToWebMapServicePage}
      goToProfilePage={goToProfilePage}
    />
  </Wrapper>
);

export default SidebarDrawer;